import { Modal } from "react-bootstrap";
import { toast } from "sonner";
import { openSupportInNewTab } from "../../../../helper/supportHelper";

type Props = {
  show: boolean;
  onClose: () => void;
  files: any;
  student: any;
};

const StudentAssignmentListFile = ({
  show,
  onClose,
  files,
  student,
}: Props) => {
  const handleGetAssignementFile = async (fileId: string, fileName: string) => {
    try {
      await openSupportInNewTab({ entityType: "HomeworkAnswer", fileName });
    } catch (error: any) {
      // console.log("Erreur lors de l'ouverture du fichier: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          Fichiers du devoir/Tp de {student?.firstname} {student?.lastname}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column gap-2">
          {files.length === 0 ? (
            <div className="text-center text-muted p-3">
              Aucun fichier disponible pour cet étudiant.
            </div>
          ) : (
            files.map((file: any) => (
              <div
                key={file.id}
                className="d-flex align-items-center justify-content-between p-2 bg-light rounded"
              >
                <div className="d-flex align-items-center overflow-hidden">
                  <i className="ti ti-file-text text-primary fs-4 me-2 flex-shrink-0" />
                  <span className="text-truncate" title={file.fileOriginalName}>
                    {file.fileOriginalName}
                  </span>
                </div>
                <button
                  // href={`/api/fileAttachement/download/${file.id}`}
                  className="btn btn-sm btn-outline-primary flex-shrink-0 ms-2"
                  title="Télécharger"
                  rel="noopener noreferrer"
                  onClick={() =>
                    handleGetAssignementFile(file.id, file.filename)
                  }
                >
                  <i className="ti ti-download" />
                </button>
              </div>
            ))
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default StudentAssignmentListFile;
